export const CANCEL_STATUS = [
  "shifter_accepted",
  "equipment_collected",
  "at_pickup_point",
];

